import { escapeHtml } from "./texto";

/** Inline SVGs share a single stroke, sizing and accessibility treatment. */
const paths = {
  bank: '<path d="m3 10 9-7 9 7H3ZM4 21h16M6 10v7m6-7v7m6-7v7"/>',
  file: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6"/><path d="M8 12h8v6H8zM8 15h8m-4-3v6"/>',
  ledger: '<path d="M12 7v14m0-14C9 4 5 4 2 5v15c3-1 7-1 10 1 3-2 7-2 10-1V5c-3-1-7-1-10 2Z"/>',
  settings: '<path d="M9.5 3h5l.6 2.5 2 .9 2.2-.8 2.5 4.3-1.8 1.7v2.3l1.8 1.7-2.5 4.3-2.2-.8-2 .9-.6 2.5h-5L8.9 20l-2-.9-2.2.8-2.5-4.3L4 13.9v-2.3L2.2 9.9l2.5-4.3 2.2.8 2-.9L9.5 3Z"/><circle cx="12" cy="12.5" r="3"/>',
  shield: '<path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"/><path d="m9 12 2 2 4-4"/>',
  check: '<path d="m5 12 4 4L19 6"/>',
  alert: '<path d="m12 3 10 18H2zM12 9v5m0 3h.01"/>',
  close: '<path d="m6 6 12 12M6 18 18 6"/>',
  arrow: '<path d="M4 12h16m-6-6 6 6-6 6"/>',
  mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 6 9 7 9-7"/>',
  mapping: '<rect x="3" y="3" width="6" height="6" rx="1"/><rect x="15" y="15" width="6" height="6" rx="1"/><path d="M9 6h9v9M6 9v9h9"/>',
  spark: '<path d="m12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5z"/>',
  upload: '<path d="M12 16V3m-5 5 5-5 5 5M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>',
  back: '<path d="M19 12H5m7-7-7 7 7 7"/>',
  save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12l4 4v12a2 2 0 0 1-2 2ZM7 3v5h9M7 21v-8h10v8"/>',
  trash: '<path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7m4-7v7"/>',
  detect: '<path d="M3 7V3h4m10 0h4v4M3 17v4h4m10 0h4v-4M7 8h10M7 12h10M7 16h6"/>',
  search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/>',
  download: '<path d="M12 3v13m-5-5 5 5 5-5M4 16v4a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4"/>',
  edit: '<path d="m15 4 5 5M4 20l5-1L21 7l-4-4L5 15z"/>',
  plus: '<path d="M12 5v14M5 12h14"/>',
  chevron: '<path d="m6 9 6 6 6-6"/>',
  eye: '<path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12"/><circle cx="12" cy="12" r="3"/>',
  calendar: '<rect x="3" y="5" width="18" height="16" rx="2"/><path d="M7 3v4m10-4v4M3 11h18m-13 5h3"/>',
  cloud: '<path d="M6 19a5 5 0 1 1 0-10 7 7 0 0 1 13-1 5.5 5.5 0 0 1 0 11z"/>',
  info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10h.01"/>',
  help: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.3a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.4v.6M12 16.8h.01"/>',
  // Cuerpo, cabeza, antenas y tres pares de patas: el bicho que todo el mundo
  // reconoce como "algo anda mal", sin depender de que se lea una etiqueta.
  bug: '<path d="M8 8a4 4 0 0 1 8 0"/><rect x="7" y="8" width="10" height="12" rx="5"/><path d="M12 12v8M7 12H3m4 5H4m3-9L5 6m12 6h4m-4 5h3m-3-9 2-2M9.5 5 8 3m6.5 2L16 3"/>',
  // Las cinco caras de la opinión, de muy insatisfecho a muy satisfecho: solo
  // cambia la boca, para que se lean como una escala y no como cinco dibujos.
  cara1: '<circle cx="12" cy="12" r="9"/><path d="M9 9.5h.01M15 9.5h.01M8 16.8q4-4 8 0"/>',
  cara2: '<circle cx="12" cy="12" r="9"/><path d="M9 9.5h.01M15 9.5h.01M8.5 16q3.5-2 7 0"/>',
  cara3: '<circle cx="12" cy="12" r="9"/><path d="M9 9.5h.01M15 9.5h.01M8.5 15h7"/>',
  cara4: '<circle cx="12" cy="12" r="9"/><path d="M9 9.5h.01M15 9.5h.01M8.5 14.5q3.5 2 7 0"/>',
  cara5: '<circle cx="12" cy="12" r="9"/><path d="M9 9.5h.01M15 9.5h.01M8 14q4 4.5 8 0"/>',
} as const;

export type IconName = keyof typeof paths;

export function icon(name: IconName): string {
  return `<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths[name]}</svg>`;
}

export function brandMark(): string {
  const favicon = typeof document !== "undefined"
    ? document.querySelector?.('link[rel="icon"]')?.getAttribute("href") : null;
  return `<img class="brand-mark" src="${escapeHtml(favicon ?? '/assets/favicon.png')}" width="40" height="40" alt="" aria-hidden="true" />`;
}
